import { render } from "./BrandCard.vue?vue&type=template&id=d832d944&scoped=true"
import script from "./BrandCard.vue?vue&type=script&lang=js"
export * from "./BrandCard.vue?vue&type=script&lang=js"

import "./BrandCard.vue?vue&type=style&index=0&id=d832d944&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d832d944"]])

export default __exports__